import { Component } from '@angular/core';
import { localizationKeys } from '../../utils/localizationKeys';

@Component({
    selector: 'app-not-found',
    template: `
        <aumico-intro-layout>
            <app-page-not-found></app-page-not-found>
            <div aumico-intro-layout-side-content>Uuuups...</div>
            <div aumico-intro-footer>
                <ng-content select="[aumico-intro-footer]"></ng-content>
            </div>
        </aumico-intro-layout>
    `,
})
export class NotFoundPage {
    localizationKeys = localizationKeys;
}
